import { render, staticRenderFns } from "./AddStorehouse.vue?vue&type=template&id=0ef92868"
import script from "./AddStorehouse.vue?vue&type=script&lang=js"
export * from "./AddStorehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports